import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  CircleCross,
} from 'AppSrc/core/components/common/svg-icons';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { groupMemberShape } from 'AppSrc/core/data-structures/api-proptypes';
import { getArraySortedByProperty } from 'AppSrc/core/utility-functions/sort-functions';
import { SearchBar } from './search-bar';
import 'AppSrc/core/components/forms/select-coordinator/view-crq-select-individual-approver.css';

const AllApproverViewTableDisplay = ({
  groupMembers,
  setCoordinator,
  onClickDisappear,
  isViewOnly,
  isAssign,
  isReAssign,
  approverCall,
  network,
  crqId,
}) => {
  const numResults = groupMembers.length;
  const [displayedName, setDisplayedName] = useState(groupMembers);
  const [ShowClose, SetShowClose] = useState(false);
  const [searchedQuery, ClearSeachecQuery] = useState('');
  useEffect(
    () => {
      setDisplayedName(groupMembers);
    },
    [setDisplayedName, groupMembers],
  );

  const searchHandler = (event) => {
    const searchQuery = event.toLowerCase();
    ClearSeachecQuery(searchQuery);
    if (searchQuery.length !== 0) {
      SetShowClose(true);
    }
    if (searchQuery.length === 0) {
      SetShowClose(false);
    }
    const displayedValue = groupMembers.filter((el) => {
      const searchValue = el.email.toLowerCase().startsWith(searchQuery);
      return searchValue;
    });
    setDisplayedName(displayedValue);
    return true;
  };
  const hideClosebutton = (e) => {
    ClearSeachecQuery('');
    setDisplayedName(groupMembers);
    SetShowClose(false);
    return true;
  };
  let results = displayedName;

  const arrFiltered = results.filter((el) => {
    console.log('test');
    return el.email !== null && el.email !== '';
  });
  const sortedResults = getArraySortedByProperty(arrFiltered, 'email');
  if (isViewOnly === true) {
    results = [];
  }

  if (!numResults) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="select-coordinator-table-vf-table">
        <div className="vf-table-head-container">
          <div className="vf-table-head">
            <div className="head-item">
              <div className="holder">
                <SearchBar
                  searchHandler={searchHandler}
                  // placeholder="Please Search Here"
                  value={searchedQuery}
                />
              </div>
              {
                ShowClose && (
                  <div className="cancle-svg-wrapper">
                    <button type="button" className="clearsearchbutton" onClick={(e) => hideClosebutton('Clear')}>
                      <CircleCross />
                    </button>
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <div className="vf-table-body">
          {
            sortedResults.map((member) => {
              const isSelected = member.id;
              console.log('memberId', isSelected);
              return (
                <div
                  className="vf-table-row-container"
                  key={member.email}
                >
                  <div className="vf-table-row-member">
                    <OptionButton
                      className="row-button no-pointer"
                      // onClick={(e) => onClickConfirm(member.email_id)}
                      option={member}
                      // disabled={isSelected}
                    >
                      <div className="row-item">
                        <span className="row-item-text">
                          {member.email}
                        </span>
                      </div>
                    </OptionButton>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </React.Fragment>
  );
};

AllApproverViewTableDisplay.propTypes = {
  groupMembers: PropTypes.arrayOf(groupMemberShape),
  setCoordinator: PropTypes.func,
  onClickDisappear: PropTypes.func,
  network: PropTypes.string,
  crqId: PropTypes.string,
  approverCall: PropTypes.func,
  isViewOnly: PropTypes.bool,
  isAssign: PropTypes.bool,
  isReAssign: PropTypes.bool,
};

export {
  AllApproverViewTableDisplay,
};
